"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("../ExtendableError"));
/**
 * Thrown when attempting operations over a closed SQL connection
 * @param {string} explanation
 */
class DisconnectedSqlStoreError extends ExtendableError_1.default {
    constructor() {
        super('Cannot perform SQL operations on closed connection.');
    }
}
exports.default = DisconnectedSqlStoreError;
